import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/car/seizedcar',
  title: '查扣五类车管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
